var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.projectListLength === 0)?_c('statistics',{on:{"click":_vm.addTeam}}):_c('introduction')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }